<template>
  <div>
    <v-container>
      <div v-if="loading">
        <div class="d-none d-md-flex">
          <div style="margin-right: 20px;">
            <v-skeleton-loader type="image" style="width: 64px; height: 64px; margin-bottom: 8px;"/>
            <v-skeleton-loader type="image" style="width: 64px; height: 64px; margin-bottom: 8px;"/>
          </div>
          <div style="margin-right: 20px;">
            <v-skeleton-loader type="image" style="width: 256px; height: 256px;"/>
          </div>
          <div style="flex: 1;">
            <v-skeleton-loader type="article" style="width: 100%;"/>
          </div>
        </div>
        <div class="d-flex flex-column d-md-none">
          <v-skeleton-loader type="article" style="width: 100%;"/>
        </div>
        <div class="d-flex justify-center">
          <v-progress-circular class="my-10" indeterminate color="primary"/>
        </div>
      </div>

      <div v-else class="d-flex flex-column flex-md-row">
        <h1 class="product-title d-md-none" style="margin-bottom: 32px;">{{ product.name }}</h1>

        <div style="min-width: 352px;" class="mr-md-10">
          <div class="d-flex flex-column-reverse flex-md-row mb-10">
            <div style="max-height: 256px; overflow-y: auto;" class="d-flex flex-row flex-md-column mr-md-6">
              <v-img aspect-ratio="1" class="product-image-preview mb-md-2 mr-2" style="flex: unset;" width="64" height="64" v-for="(image, i) in product.images" :key="image.key" :src="image.sm" :srcset="`${image.md} 2x`" :class="{ 'selected': selectedImage === i }" @click="selectedImage = i"></v-img>
            </div>
            <div class="mb-5 mb-md-0">
              <v-img v-if="product.images.length !== 0" aspect-ratio="1" class="product-image" min-height="256" min-width="256" :lazy-src="product.images[selectedImage].sm" :src="product.images[selectedImage].md" :srcset="`${product.images[selectedImage].lg} 2x`" @click="selectedImageOverlay = true">
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                        color="grey-lighten-4"
                        indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
              <div v-else style="font-size: 9px; opacity: 0.5; display: flex; align-items: center; justify-content: center; width: 256px; height: 256px;">Нет изображения товара</div>
            </div>
          </div>

          <a class="product-category" style="display: inline-block; margin-bottom: 20px;" @click="showRegisterForm()">{{ product.category_name }}</a>

          <h2 class="product-properties-title" style="margin-bottom: 10px;">Характеристики:</h2>
          <div class="product-properties-text mb-5 mb-md-0">
            <div class="d-inline-block" style="width: 100%;">
              <div class="d-flex" style="margin-bottom: 8px;">
                <div style="opacity: 0.7;">Производитель</div>
                <div class="product-properties-dash"></div>
                <div style="color: #000000;">{{ product.manufacturer_name ?? '&mdash' }}</div>
              </div>
              <div class="d-flex" style="margin-bottom: 8px;">
                <div style="opacity: 0.7;">Страна производитель</div>
                <div class="product-properties-dash"></div>
                <div style="color: #000000;">{{ product.manufacturer_country ?? '&mdash' }}</div>
              </div>
              <div class="d-flex" style="margin-bottom: 8px;">
                <div style="opacity: 0.7;">Единица измерения</div>
                <div class="product-properties-dash"></div>
                <div style="color: #000000;">{{ product.unit_full_name ?? '&mdash' }}</div>
              </div>
              <div class="d-flex" style="margin-bottom: 8px;">
                <div style="opacity: 0.7;">Артикул</div>
                <div class="product-properties-dash"></div>
                <div style="color: #000000;">{{ product.sku ?? '&mdash' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div style="position: relative; max-height: 500px; flex: 1; display: flex; flex-direction: column;">
          <div class="product-title d-none d-md-inline-block" style="margin-bottom: 32px;">{{ product.name }}</div>
          <div class="product-description" style="flex: 1; white-space: pre-line; overflow-y: auto;">
            <div class="d-md-none" v-html="product.description_short"></div>
            <div class="d-none d-md-inline" v-html="product.description"></div>
          </div>
          <div class="d-none d-md-block" style="position: absolute; bottom: 0; width: 100%; height: 40px; background: linear-gradient(0, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);"></div>
        </div>
      </div>
    </v-container>

    <v-container :class="{ 'dimmed': loading }">
      <div class="d-flex flex-column-reverse flex-md-row align-center">
        <div class="mb-md-10 mr-md-10">
          <h2 style="font-size: 28px; line-height: 130%; font-weight: 400; color: #000000; margin-bottom: 32px;">О проекте</h2>
          <div style="font-weight: 400; font-size: 14px; line-height: 150%; color: #000000; margin-bottom: 60px; opacity: 0.7; white-space: pre-line;" v-html="`<strong>Atis Trade</strong> — онлайн-платформа для стоматологических клиник и зуботехнических лабораторий, которая позволяет быстро найти все необходимые материалы, инструменты, оборудование и запасные части по самым выгодным ценам.

            Мы создали сервис, который объединяет запросы клиник и зуботехнических лабораторий с самыми выгодными предложениями поставщиков по всей России.`">
          </div>
          <div>
            <v-btn href="https://buyer.atistrade.ru/" target="_blank" large outlined color="primary" min-width="200px" style="margin-bottom: 20px; margin-right: 40px;">Для клиник</v-btn>
            <v-btn href="https://seller.atistrade.ru/" target="_blank" large outlined color="primary" min-width="200px" style="margin-bottom: 20px;">Для поставщиков</v-btn>
          </div>
        </div>
        <v-img src="@/assets/main.png" class="mb-10 mb-md-0"></v-img>
      </div>
    </v-container>

    <div style="height: 40px;"></div>

    <v-container :class="{ 'dimmed': loading }">
      <div class="d-flex justify-center">
        <div class="d-flex flex-column-reverse flex-md-row" style="background: linear-gradient(94.26deg, #1B8EE9 33.84%, rgba(40, 150, 239, 0.79) 92.41%); border-radius: 25px; width: 1062px; min-height: 300px;">
          <div style="position: relative;">
            <img class="d-none d-md-block" style="transform: translateY(-32px);" src="@/assets/bonuses.png"/>
            <img class="d d-md-none v-responsive" src="@/assets/bonuses.png"/>
          </div>
          <div class="d-flex flex-column align-start px-10 pb-0 pb-md-10 pt-10" style="justify-content: space-evenly;">
            <h2 style="color: #ffffff; font-style: normal; font-weight: 700; font-size: 32px; line-height: 130%; margin-bottom: 20px;">Получите приветственные <br>бонусы за регистрацию</h2>
            <div style="color: #ffffff; font-style: normal; font-weight: 700; font-size: 16px; line-height: 150%; margin-bottom: 20px;">1 бонус = 1 ₽</div>
            <v-btn large color="white" style="color: #1B7DC9;" elevation="0" min-width="200px" @click="showRegisterForm()">Зарегистрироваться</v-btn>
          </div>
        </div>
      </div>
    </v-container>

    <div style="height: 80px;"></div>

    <main-footer></main-footer>

    <v-overlay v-if="!loading" :value="selectedImageOverlay" @click="selectedImageOverlay = false">
      <v-img v-if="product.images[selectedImage]" :src="product.images[selectedImage].original" style="cursor: zoom-out;">
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
                color="grey-lighten-4"
                indeterminate
            ></v-progress-circular>
          </div>
        </template>
      </v-img>
    </v-overlay>
  </div>
</template>

<script>
import MainFooter from "@/components/MainFooter.vue";

import { callAPI } from "@/services/api";

export default {

  name: "ProductView",

  components: { MainFooter },

  inject: [ "showError", "showRegisterForm" ],

  data() {
    return {
      loading: true,
      product: null,
      selectedImage: 0,
      selectedImageOverlay: false
    };
  },

  async beforeCreate() {
    let slug = null;
    let id = this.$route.params.id;
    const dash_index = id.lastIndexOf('-');
    if (dash_index !== -1) {
      slug = id.substring(0, dash_index);
      id = id.substring(dash_index + 1);
    }

    try {
      this.loading = true;
      this.product = await callAPI('POST', '/api/getProduct', { product_id: id });
      this.loading = false;

      if (this.product.slug && this.product.slug !== slug) {
        await this.$router.push({
          name: "product",
          params: { id: `${this.product.slug}-${this.product.id}` },
        });
      }

      // change page title
      document.title = `Atis Trade | ${this.product.name}`;

    } catch (error) {
      this.showError(error.message, { ok: 'Вернуться на главную' })
          .then(() => this.$router.push('/'));
    }
  }
};
</script>

<style lang="scss" scoped>
.product-title {
  font-weight: 400;
  font-size: 28px;
  line-height: 130%;

  color: #000000;
}

.product-description {
  font-size: 14px;
  line-height: 150%;

  opacity: 0.7;
  color: #000000;
}

.product-properties-title {
  font-weight: 400;
  font-size: 18px;
  line-height: 130%;

  color: #414041;
}
.product-properties-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;

  color: #414041;
}
.product-properties-dash {
  border-bottom: 1px dotted #ACAEB1;
  flex: 1;
  min-width: 20px;
  margin: 4px;
}

.product-category {
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;

  text-decoration: none;

  color: rgba(0, 0, 0, 0.25);
}
.product-category:hover {
  text-decoration: underline;
}

.product-image-preview {
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.product-image-preview:hover {
  border-color: #c0c0c0;
  opacity: 0.75;
}
.product-image-preview.selected {
  border-color: #1B7DC9;
}

.product-image {
  cursor: zoom-in;
  transition: opacity 0.2s;
}
.product-image:hover {
  opacity: 0.75;
}

.dimmed {
  opacity: 0.5;
}
</style>
